<script lang="ts">
  import type { IntegrationDetails, MarketManAuthInfo, TevalisAuthInfo } from "../../helpers/types";

  import { tevalisAuthSetup, marketAuthSetup } from "../../helpers/integrations-api";
  import TevalisAuth from "./TevalisAuth.svelte";
  import MarketmanAuth from "./MarketmanAuth.svelte";
  import StepSuccessIcon from "./StepSuccessIcon.svelte";
  import { track } from "../../helpers/mixpanel";
  import { selectedBuyer } from "../../stores/buyer";
  import { externalContactsStore } from "../../stores/integrations-store";

  export let integration: IntegrationDetails;
  export let isConnected: boolean;
  export let onPopupClosed = (_isOAuth: boolean) => {};
  export let stepNumber: number = 0;
  export let isActive: boolean = false;

  const isOAuth =
    integration.platform.toLowerCase() === "xero" ||
    integration.platform.toLowerCase() === "quickbooksonline" ||
    integration.platform.toLowerCase() === "square";

  const onConnectOAuth = () => {
    track("integration_connect_oauth_click", {
      buyer_id: $selectedBuyer?.id,
      buyer_name: $selectedBuyer?.name,
      integration_id: integration.id,
      platform: integration.platform,
      is_setup: !stepNumber,
    });

    const height = 900;
    let width = 600;
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2.5;

    const popup = window.open(
      `/plug/authorization/${integration.platform.toLowerCase()}?code=${integration.setup_token}`,
      "popup",
      `popup=true, height=${height}, width=${width}, left=${left}, top=${top}`
    );
    const checkPopup = setInterval(() => {
      if (popup?.window?.location?.href.includes("setup")) {
        popup?.close();
      }
      if (!popup || !popup.closed) return;
      onPopupClosed(false);
      clearInterval(checkPopup);
    }, 500);
  };

  const handleTevalisAuthSubmit = (tevalisAuth: TevalisAuthInfo) => {
    track("integration_connect_tevalis_click", {
      buyer_id: $selectedBuyer?.id,
      buyer_name: $selectedBuyer?.name,
      integration_id: integration.id,
      platform: integration.platform,
      is_setup: !stepNumber,
    });

    tevalisAuthSetup(tevalisAuth).then((result) => {
      if (result) {
        onPopupClosed(false);
      }
    });
  };

  const handleMarketManAuthSubmit = (marketManAuth: MarketManAuthInfo) => {
    track("integration_connect_marketMan_click", {
      buyer_id: $selectedBuyer?.id,
      buyer_name: $selectedBuyer?.name,
      integration_id: integration.id,
      platform: integration.platform,
      is_setup: !stepNumber,
    });
    marketAuthSetup(marketManAuth).then((result) => {
      if (result) {
        onPopupClosed(false);
      }
    });
  };
</script>

<div class="container">
  <div class="supply-line-header">
    <StepSuccessIcon
      success={isConnected && !!$externalContactsStore?.authenticated}
      {isActive}
      {stepNumber}
    />
    {#if integration.platform === "Square"}
      {#if $externalContactsStore?.error}
        <h4 class="subtitle">
          {#if $externalContactsStore?.error === "UNAUTHORIZED"}
            unauthorized
          {:else if $externalContactsStore?.error === "ACCESS_TOKEN_EXPIRED"}
            connection expired
          {:else if $externalContactsStore?.error === "ACCESS_TOKEN_REVOKED"}
            connection revoked
          {/if}
        </h4>
      {:else}
        <h4 class="subtitle">connect your account</h4>
      {/if}
    {:else}
      <h4 class="subtitle">connect your account</h4>
    {/if}

    {#if !isConnected && isOAuth}
      <button class="contact-us-btn" on:click={() => onConnectOAuth()}
        >log in to {integration.platform}
      </button>
    {:else if isOAuth}
      <button class="contact-us-btn btn-neutral" on:click={() => onConnectOAuth()}
        >reconnect
      </button>
    {/if}
  </div>
  {#if !isOAuth}
    <div class="content">
      {#if integration.platform === "Tevalis"}
        <TevalisAuth
          {integration}
          onAuthSubmit={(tevalisAuth) => handleTevalisAuthSubmit(tevalisAuth)}
        />
      {:else}
        <MarketmanAuth
          {integration}
          onAuthSubmit={(marketManAuth) => handleMarketManAuthSubmit(marketManAuth)}
        />
      {/if}
    </div>
  {/if}
</div>

<style>
  .container {
    border-radius: 8px;
    background-color: white;
    margin-bottom: 18px;
  }

  .supply-line-header {
    display: flex;
    padding: 18px;
    border-bottom: 1px solid;
    border-color: var(--rekki-neutral-01);
    align-items: center;
  }
  .content {
    padding: 18px;
    display: flex;
  }

  .subtitle {
    font-size: 18px;
    font-weight: bold;
  }

  .contact-us-btn {
    border-radius: 100px;
    padding: 10px 20px;
    background-color: var(--rekki-accent);
    color: var(--rekki-light);
    border: none;
    justify-self: flex-end;
    font-family: "REKKI-OCD";
    white-space: nowrap;
    text-transform: uppercase;
    margin-left: auto;
    font-size: 16px;
  }

  .btn-neutral {
    background-color: var(--rekki-neutral-01);
    color: var(--rekki-dark);
  }
</style>
